import { createFileRoute } from '@tanstack/react-router';
import { ScopedUsersTable } from '../../components/scoped/ScopedUsersTable';
import { PLATFORM_TENANT_DESCRIPTOR } from '../../components/scoped/scopeDescriptors';

// Pestaña Usuarios del drill-down. El tenantId sale del PATH (no del user logueado) y se pasa como
// `scopeRef` al motor compartido `ScopedUsersTable`, que con `PLATFORM_TENANT_DESCRIPTOR` consume
// platformApi.*TenantUser sobre ese tenant.
export const Route = createFileRoute('/_authenticated/_layout/platform/tenants/$tenantId/users')({
    component: TenantUsers,
});

function TenantUsers() {
    const { tenantId } = Route.useParams();
    return <ScopedUsersTable descriptor={PLATFORM_TENANT_DESCRIPTOR} scopeRef={tenantId} />;
}
